@font-face {
  font-family: KaTeX_AMS;
  src: url("/assets/fonts/KaTeX_AMS-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Caligraphic;
  src: url("/assets/fonts/KaTeX_Caligraphic-Bold.woff2");
  font-weight: 700;
  font-display: block;
}
@font-face {
  font-family: KaTeX_Caligraphic;
  src: url("/assets/fonts/KaTeX_Caligraphic-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Fraktur;
  src: url("/assets/fonts/KaTeX_Fraktur-Bold.woff2");
  font-weight: 700;
  font-display: block;
}
@font-face {
  font-family: KaTeX_Fraktur;
  src: url("/assets/fonts/KaTeX_Fraktur-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Main;
  src: url("/assets/fonts/KaTeX_Main-Bold.woff2");
  font-weight: 700;
  font-display: block;
}
@font-face {
  font-family: KaTeX_Main;
  src: url("/assets/fonts/KaTeX_Main-BoldItalic.woff2");
  font-weight: 700;
  font-style: italic;
  font-display: block;
}
@font-face {
  font-family: KaTeX_Main;
  src: url("/assets/fonts/KaTeX_Main-Italic.woff2");
  font-style: italic;
  font-display: block;
}
@font-face {
  font-family: KaTeX_Main;
  src: url("/assets/fonts/KaTeX_Main-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Math;
  src: url("/assets/fonts/KaTeX_Math-BoldItalic.woff2");
  font-weight: 700;
  font-style: italic;
  font-display: block;
}
@font-face {
  font-family: KaTeX_Math;
  src: url("/assets/fonts/KaTeX_Math-Italic.woff2");
  font-style: italic;
  font-display: block;
}
@font-face {
  font-family: KaTeX_SansSerif;
  src: url("/assets/fonts/KaTeX_SansSerif-Bold.woff2");
  font-weight: 700;
  font-display: block;
}
@font-face {
  font-family: KaTeX_SansSerif;
  src: url("/assets/fonts/KaTeX_SansSerif-Italic.woff2");
  font-style: italic;
  font-display: block;
}
@font-face {
  font-family: KaTeX_SansSerif;
  src: url("/assets/fonts/KaTeX_SansSerif-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Script;
  src: url("/assets/fonts/KaTeX_Script-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Size1;
  src: url("/assets/fonts/KaTeX_Size1-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Size2;
  src: url("/assets/fonts/KaTeX_Size2-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Size3;
  src: url("/assets/fonts/KaTeX_Size3-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Size4;
  src: url("/assets/fonts/KaTeX_Size4-Regular.woff2");
  font-display: block;
}
@font-face {
  font-family: KaTeX_Typewriter;
  src: url("/assets/fonts/KaTeX_Typewriter-Regular.woff2");
  font-display: block;
}
ch-showcase {
  display: contents;
}

.barcode-scanner-test-main-wrapper {
  display: grid;
  grid-template-rows: 1fr max-content;
  gap: var(--spacing--m, var(--mer-spacing--xs));
}